import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Link from 'housecall-ui/dist/DesignSystem/Navigation/Link/Link';
import FlatRatePricingIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/FlatRatePricingIcon';

const VIDEO_URL = 'https://fast.wistia.net/embed/iframe/925tisqlap?autoPlay=false';
const GUIDE_URL = 'https://help.housecallpro.com/en/articles/5461788-getting-started-with-flat-rate-services-pricing';

const FlatRatePricingStrategy = {
  previewInfo: {
    name: 'Flat rate pricing',
    iconSvg: <FlatRatePricingIcon size="xlarge" />,
  },
  headerInfo: {
    name: 'Flat rate pricing',
    category: 'Build your pricebook to maximize your revenue',
    details: (
      <div>
        Protect your margins and keep your pricing competitive with Housecall Pro’s new flat rate pricing tool.
        <br />
        <br />
        Build out your flat rate services by including your labor, material cost and mark ups all integrated within the
        Housecall Pro’s Price Book.
        <br />
        <br />
        Take the guessing game out of your pricing and invest the time to build your strategy.
        <br />
        <br />
        <Typography>Considering flat rate pricing? Check out the video below to learn more.</Typography>
      </div>
    ),
    iconSvg: <FlatRatePricingIcon size="xlarge" />,
  },
  media: {
    wistiaLink: VIDEO_URL,
  },
  sellingPoints: {
    description: (
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Typography>
            If you&apos;re ready to get started, follow our step by step guide{' '}
            <Link href={GUIDE_URL} rel="noopener" target="_blank">
              HERE
            </Link>
            .
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Not Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    hideCard: true,
  },
  supportContacts: [],
};

export default FlatRatePricingStrategy;
